import gql from "graphql-tag";
const getCashManagementBalance = gql(`
query MyQuery ($fund: String, $investor: String, $date: date) {
  CashManagement_cashManagementBalances (order_by: {Date: asc}, where: { Investor: { _eq: $investor }, Date: {_eq: $date }}) {
    CashBalance
    CkgBalance
    CoInvestCKGBalance
    Date
    Fund
    Investor
    MMABalance
    TrancheIIBalance
    CoInvestReimburseBalance
    TrancheIIReimburseBalance
    CoMMABalance
    TrancheIIMMABalance
    BalancedTotal
    CoInvestTotal
    TrancheIITotal
  }
}`
)
export default getCashManagementBalance;
